/*
  Gratis-Geschenk im Cart Drawer automatisch hinzufügen und wieder entfernen.
  Ersetzt autoAddToCart() aus pmgw-custom.js (die Funktion beendet sich dort,
  weil das Daten-Element jetzt id="free-gift-auto-add" heißt).

  Daten kommen aus sections/cart-drawer.liquid (#free-gift-auto-add).
  Ausgelöst wird bei jedem "cart:change" des Themes (hinzufügen, Menge ändern,
  entfernen) und einmal beim Laden der Seite.

  Entfernt der Kunde das Geschenk selbst, wird das im Warenkorb-Attribut
  _free_gift_declined gespeichert und das Geschenk nicht erneut hinzugefügt.
  Der Drawer zeigt dann das Angebot aus snippets/cart-free-gift.liquid. Legt der
  Kunde das Geschenk dort wieder hinein, wird das Attribut gelöscht.
*/
(function () {
  // Das Theme baut den Drawer teils per createContextualFragment neu auf, wodurch
  // dieses Skript erneut ausgeführt wird. Nur eine Instanz darf laufen.
  if (window.freeGiftAutoAddInitialized) return;

  const dataEl = document.getElementById("free-gift-auto-add");
  if (!dataEl) return;

  window.freeGiftAutoAddInitialized = true;

  const SYNC_EVENT = "free-gift:sync";
  const DECLINED_ATTRIBUTE = "_free_gift_declined";
  const method = dataEl.dataset.method;
  const giftIDs = JSON.parse(dataEl.dataset.giftIds).filter(Boolean).map(Number);
  const skus = JSON.parse(dataEl.dataset.skus).filter(Boolean);
  const threshold = Number(dataEl.dataset.threshold) * 100;

  if (giftIDs.length === 0) return;

  let running = false;
  let pending = false;
  let declined = null; // null = noch nicht aus dem Warenkorb gelesen

  const isGift = (item) => giftIDs.includes(item.id);

  // Bedingung prüfen, ohne das Geschenk selbst mitzuzählen: Fällt der Rabatt weg,
  // kostet das Geschenk den vollen Preis und würde sonst die Schwelle "erfüllen".
  function qualifies(cart) {
    const giftTotal = cart.items
      .filter(isGift)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    const matchingItems = cart.items.filter((item) => !isGift(item) && skus.includes(item.sku));

    if (method === "bestellsumme") return cart.total_price - giftTotal >= threshold;
    if (method === "produkt") return matchingItems.length > 0;
    if (method === "bestellsumme_produkt") {
      return matchingItems.reduce((sum, item) => sum + item.price * item.quantity, 0) > threshold;
    }
    return false;
  }

  async function fetchCart() {
    return (await fetch(`${Shopify.routes.root}cart.js`)).json();
  }

  async function postJSON(url, body) {
    const response = await fetch(`${Shopify.routes.root}${url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(`${url} ${response.status}: ${await response.text()}`);
  }

  // Zähler, Leisten und Drawer aktualisieren wie bei einer Änderung durch das Theme.
  // baseEvent verhindert, dass sync() auf das eigene Event erneut reagiert.
  async function announceCartChange() {
    const drawer = document.querySelector("cart-drawer");
    const sectionId = drawer?.closest(".shopify-section")?.id.replace("shopify-section-", "");
    const [cart, sections] = await Promise.all([
      fetchCart(),
      sectionId ? fetch(`${Shopify.routes.root}?sections=${sectionId}`).then((r) => r.json()) : {},
    ]);
    cart.sections = sections;

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: SYNC_EVENT, cart },
      })
    );
  }

  function saveDeclined(value) {
    declined = value;
    return postJSON("cart/update.js", { attributes: { [DECLINED_ATTRIBUTE]: value ? "true" : "" } });
  }

  async function syncOnce() {
    // Immer den aktuellen Warenkorb lesen: Event-Daten können schon veraltet sein.
    const cart = await fetchCart();
    const giftLines = cart.items.filter(isGift);
    const shouldHaveGift = qualifies(cart);

    if (declined === null) declined = cart.attributes?.[DECLINED_ATTRIBUTE] === "true";

    if (shouldHaveGift && giftLines.length === 0 && !declined) {
      await postJSON("cart/add.js", { items: giftIDs.map((id) => ({ id, quantity: 1 })) });
      return true;
    }
    if (!shouldHaveGift && giftLines.length > 0) {
      const updates = Object.fromEntries(giftLines.map((item) => [item.key, 0]));
      await postJSON("cart/update.js", { updates });
      return true;
    }
    return false;
  }

  // Läuft nie parallel; Auslöser während eines Laufs führen zu genau einem weiteren Lauf.
  async function sync() {
    if (running) {
      pending = true;
      return;
    }

    running = true;
    let changed = false;
    try {
      do {
        pending = false;
        changed = (await syncOnce()) || changed;
      } while (pending);

      if (changed) await announceCartChange();
    } catch (error) {
      console.error("Free gift sync failed:", error);
    } finally {
      running = false;
    }
  }

  // Das Theme meldet jede Mengenänderung im Drawer vorab (auch "Entfernen").
  // Geht das Geschenk auf 0, hat der Kunde es bewusst entfernt.
  document.addEventListener("line-item:will-change", (event) => {
    const lineKey = event.target.querySelector("[data-line-key]")?.getAttribute("data-line-key");
    const variantId = Number(lineKey?.split(":")[0]);
    if (event.detail?.targetQuantity === 0 && giftIDs.includes(variantId)) {
      saveDeclined(true).catch((error) => console.error("Free gift sync failed:", error));
    }
  });

  document.addEventListener("cart:change", (event) => {
    if (event.detail?.baseEvent === SYNC_EVENT) return;

    // Kunde hat das Geschenk selbst (z. B. über das Angebot) wieder hinzugefügt
    if (declined && event.detail?.baseEvent === "variant:add" && event.detail.cart?.items?.some(isGift)) {
      saveDeclined(false).catch((error) => console.error("Free gift sync failed:", error));
    }

    sync();
  });

  sync();
})();
